import type { AnswerForm as AnswerFormSchema } from "../../../packages/contracts/src/production.js";

type FieldSchema = { type?: unknown; description?: unknown; enum?: unknown; items?: unknown };
export type Field = { name: string; schema: FieldSchema; kind: "string" | "number" | "integer" | "boolean" | "json"; required: boolean };

export function fieldsOf(form: AnswerFormSchema | undefined): Field[] {
  const required = new Set(form?.required ?? []);
  return Object.entries(form?.properties ?? {}).map(([name, value]) => {
    const schema = (value && typeof value === "object" ? value : {}) as FieldSchema;
    const kind = schema.type === "string" || schema.type === "number" || schema.type === "integer" || schema.type === "boolean" ? schema.type : "json";
    return { name, schema, kind, required: required.has(name) };
  });
}

export const label = (name: string) => { const text = name.replaceAll("_", " "); return text.charAt(0).toUpperCase() + text.slice(1); };

/** Builds the answer object with the types of the form. Returns an error message when a value is not valid. */
export function buildAnswer(form: AnswerFormSchema | undefined, values: Record<string, string | boolean>): { answer: Record<string, unknown> } | { error: string } {
  const answer: Record<string, unknown> = {};
  for (const field of fieldsOf(form)) {
    const value = values[field.name];
    if (field.kind === "boolean") { answer[field.name] = value === true; continue; }
    const text = typeof value === "string" ? value : "";
    if (!text.trim()) {
      if (field.required) return { error: `${label(field.name)} is necessary.` };
      continue;
    }
    if (field.kind === "string") answer[field.name] = text;
    else if (field.kind === "number" || field.kind === "integer") {
      const number = Number(text);
      if (!Number.isFinite(number) || (field.kind === "integer" && !Number.isInteger(number))) return { error: `${label(field.name)} must be a ${field.kind === "integer" ? "whole number" : "number"}.` };
      answer[field.name] = number;
    } else {
      try { answer[field.name] = JSON.parse(text); } catch { return { error: `${label(field.name)} is not valid JSON.` }; }
    }
  }
  return { answer };
}
